module.exports = __webpack_public_path__ + "img/t6-salmon.bb368f8f.png";